import React, { FC } from 'react'
import { StoreShippingType } from 'types/storeShipping'
import { CautionCard, DeliveryOrderCardList } from 'components/Card'
import { OrderTime, OrderType } from 'types/checkout'
import { UserType } from 'types/user'

type Props = {
  orders: OrderType[]
  orderTimes: OrderTime[]
  sortType: 'checkout_at' | 'scheduled_delivery_at'
  storeShippingList: StoreShippingType[]
  users: UserType[]
}

const DeliveryOrderContainer: FC<Props> = (props) => {
  const { orders, orderTimes, sortType, storeShippingList, users } = props

  if (storeShippingList.length > 0 && orders.length > 0) {
    return (
      <DeliveryOrderCardList
        orders={orders}
        orderTimes={orderTimes}
        sortType={sortType}
        storeShippingList={storeShippingList}
        users={users}
      />
    )
  } else {
    return (
      <CautionCard
        align={'center'}
        caution={'条件に合う注文がありません'}
        description={'ほかの方法で検索してみてください'}
      />
    )
  }
}

export default DeliveryOrderContainer
